import { Inline, breakpoints } from '@etg/wings';
import { Checkbox } from '@eti/form';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { DIRECT_FLIGHT } from '../constants/formFields';

const labelStyles = css`
  cursor: pointer;
  font-size: 0.875rem;
`;

const inlineStyles = css`
  @media (min-width: ${breakpoints._768}) {
    height: 3rem;
  }
`;

const DirectFlight = () => {
  const { t } = useTranslation();

  return (
    <Inline alignY="center" className={inlineStyles} noWrap spacing={8}>
      <Checkbox
        data-testid={`${DIRECT_FLIGHT}-input`}
        id="directFlightCheckbox"
        name={DIRECT_FLIGHT}
      />
      <label className={labelStyles} htmlFor="directFlightCheckbox">
        {t('Air.Search.DirectFlightsOnly')}
      </label>
    </Inline>
  );
};

export default DirectFlight;
